/**
 * Builds brand links
 * @param {Array} vendors
 */
export default (vendors) => {
  let html = '';

  if (vendors) {
    vendors.forEach((vendor) => {
      const item = `
        <a class="tw-py-3 tw-gap-2 flex justify-between border-b border-warm-gray-100 no-underline"
           href="${Shopify.routes.root}search?q=${vendor}">
          ${vendor}
        </a>
      `;

      html += item;
    });
  }

  return html;
};
